import { wrapper } from 'redux/store';
import CaseStudiesContainer from 'containers/CaseStudies';
import { handleError } from 'utils/error';
import pageApi from 'redux/apis/page';

const Project = ({
  introSection,
  ...rest
}) => (
  <CaseStudiesContainer
    introSection={introSection}
    {...rest}
  />
);

export const getStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps = wrapper.getStaticProps((store) => async ({ params: { project } }) => {
  try {
    await store.dispatch(pageApi.endpoints.fetchPage.initiate(project));
    const state = store.getState();
    const { data } = pageApi.endpoints.fetchPage.select(project)(state);

    if (!data) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        slug: project,
        pageFetchQuery: project,
      },
      revalidate: 86400,
    };
  } catch (error) {
    handleError({
      error,
      message: 'Error in the Project.getStaticProps function',
    });

    return { notFound: true };
  }
});

export default Project;
